/**
 * Supabase — widget-first stránka (2.1).
 * Panely: widgets/registry.supabase.tsx + pages/modules/supabase/panels.tsx
 * Katalog: module-ui-catalog (stejné taby na /infra/nodes/:id).
 */
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('supabase');

export default function SupabaseModule() {
  return <ModuleWorkspace def={DEF} hideHeader defaultTab='instances' />;
}

/** Plugin editor pro jiné stránky (network service detail) — zůstává z panels. */
export { SupabaseServiceEditor } from './supabase/panels';
